/*
	Por padrão usamos qualquer valor
	passado na propriedade body em options
	como o body da nossa requisição
*/
export default ({ options:{ body } }) => body